import axios from "axios";
import _ from "lodash";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

 const IsAuth = ({ children }) => {
  const token = localStorage.getItem("token");
  const role_id = localStorage.getItem("role_id");
  return token && role_id  ? children : <Navigate to="/login" />;
};

export default IsAuth

export const IsLoggedIn = ({children})=> {
  const token = localStorage.getItem("token");
  const role_id = localStorage.getItem("role_id");
  return token && role_id  ?  <Navigate to="/dashboard" /> : children
}

export const ProtectedRoute = ({children})=>{
  const [data, setData] = useState([])
  const [menuUrl, setMenuUrl] = useState(true);

  const location = useLocation();
  const currentUrl = location.pathname;
  const role_id = localStorage.getItem("role_id");

  function getSideData(){
    axios.get(`v1/menuauth/list/1/${role_id}`)
    .then(res=>{
     setData(res.data)
    //  console.log(res.data)
    })
    .catch(err=>{
      console.log(err.response)
    })
  }
  useEffect(()=>{
    getSideData()
  },[])
  // console.log(menuUrl, currentUrl)
  useEffect(()=>{
   if(data.length > 0){
    const illnessSubData = _.map(data, (value) => value.submenus);
    // console.log(illnessSubData)
 
     const isUnauthorized = illnessSubData.some((item) => {
      //  console.log(item)
       return item.some((submenu) =>submenu.sub_menu_url == `${currentUrl}`);
     });
//  console.log(isUnauthorized)
     if (isUnauthorized || currentUrl==='/dashboard') {
       setMenuUrl(true);
     } else {
       setMenuUrl(false);
     }
   }
  },[data])

return menuUrl ? children : <Navigate to="*" />;
}